import React from "react";
import { GenreListLoaderTemplate } from "themes/administration/genre/components";

function GenreListLoader(props) {
    return <GenreListLoaderTemplate {...props} />;
}

export default GenreListLoader;
